<template>
    <div>
        <form-header title="Anmeldung Prüfungen"></form-header>
        <ValidationObserver ref="form" v-show="!formbehaviour.showEditDialog">
            <div class="bg-primary">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <transition name="fade">
                        <div class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                            v-show="formbehaviour.alertrequired">
                            <div class="md:grid md:grid-cols-1 md:gap-3">
                                <div class="md:col-span-1">
                                    <h3 class="leading-3">
                                        Bitte überprüfen Sie Ihre Eingabe!
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </transition>

                    <form-section title="Registrierung">
                        <drop-down label="Musikschule" rules="required" v-model="musikschuleId"
                            :values="formdata.musikschulen"></drop-down>
                        <text-input label="Kontaktperson: Vorname" rules="required" columns="3"
                            v-model="ansuchen.vornameKontakt"></text-input>
                        <text-input label="Nachname" columns="3" rules="required" v-model="ansuchen.nachnameKontakt">
                        </text-input>
                        <text-input label="E-Mail" rules="required|email" v-model="ansuchen.email"></text-input>
                        <text-input label="Mobiltelefon" rules="required" v-model="ansuchen.telefon"></text-input>
                    </form-section>
                    <form-section title="Zeit und Ort"
                        subtitle="Die Werte werden für jede neu erstellte Prüfung übernommen. Sie können die Werte beliebig oft ändern.">
                        <text-input label="Datum" rules="date" columns="3" v-model="formdata.datum"></text-input>
                        <text-input label="PLZ, Ort und Adresse der Prüfung" columns="3"
                            v-model="formdata.pruefungsOrt"></text-input>



                        <button @click="newPruefung()" type="button"
                            class="block mt-3 text-center col-span-6 md:col-span-3 px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">Prüfung
                            hinzufügen</button>


                    </form-section>


                    <div class="my-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <h3 class="text-lg font-medium leading-6 sm:mb-6 text-gray-900 text-center">Ungespeicherte
                            Prüfungen</h3>
                        <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
                            <table ref="pruefungenTable" v-if="ansuchen.pruefungen"
                                class="md:table-fixed table-auto  overflow-x-auto container mx-auto px-4 text-left divide-gray-200  align-top">
                                <thead>
                                    <tr>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Bearbeiten</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Datum</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Ort</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Fach</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Rahmenzeit</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Anzahl SchülerInnen</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Prüfung</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Vorsitz<br>Hauptfachlehrender<br>Fachk. Beisitz<br>Ext. fachk. Beisitz</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Anmerkung</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pruefung, index) in ansuchen.pruefungen" :key="index"
                                        :class="index % 2 == 0 ? 'bg-white' : 'bg-gray-100'">
                                        <td>
                                            <div class="flex flex-row">
                                                <button
                                                    class="md:px-6 md:py-4 px-1 py-2 focus:outline-none focus:shadow-outline-red text-sm leading-5 hover:bg-red-600 text-red-600 hover:text-red-200 font-bold items-center"
                                                    @click="formdata.selectedPruefungIndex = index; formbehaviour.showDeleteDialog = true;">

                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                                        <path stroke-width="2"
                                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg></button>
                                                <button @click="editPruefung(index)"
                                                    class="md:px-6 md:py-4 px-1 py-2 text-sm focus:outline-none focus:shadow-outline-blue leading-5 font-medium hover:bg-blue-600 text-blue-600 hover:text-blue-200 justify-center">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                                        <path stroke-width="2"
                                                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg></button>
                                            </div>
                                        </td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ getDate(pruefung.datum) }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.pruefungsOrt }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ getFachById(pruefung.fachId) }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.rahmenzeit }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.anzahlSchueler }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.pruefungsArt }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.vorsitz }}<br>{{ pruefung.hauptfachlehrender }}<br>{{
                                                    pruefung.fachkundigerBeisitz
                                            }}<br>{{ pruefung.externerFachkundigerBeisitz
}}
                                        </td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.anmerkungen }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <form-section title="Sonstiges">
                        <text-block :content="textbausteinfuer('pruefungsordnung.hinweise')" class="col-span-6">
                        </text-block>
                        <check-box rules="required" label="Ich bestätige hiermit die Richtigkeit meiner Angaben."
                            class="col-span-6" v-model="richtigBestaetigung"></check-box>
                    </form-section>
                    <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <div class="">
                            <div class="md:col-span-1">&nbsp;</div>
                            <div class="flex flex-col">

                                <button @click="sendAnsuchen()" type="button"
                                    class="mb-3 mx-auto md:w-96 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                    Speichern und Anmelden
                                </button>
                                <button @click="generatePdf(formdata.existierendePruefungen)" type="button"
                                    data-tooltip="ACHTUNG: Die neu angelegten Prüfungen werden erst nach dem Speichern im Pdf angezeigt."
                                    class="mx-auto md:w-96 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                    Vorhandene Termine als Pdf speichern
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <h3 class="text-lg font-medium leading-6 sm:mb-6 text-gray-900 text-center">Bereits vorhandene
                            Termine</h3>
                        <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
                            <table ref="pruefungenTable" v-if="formdata.existierendePruefungen[0]"
                                class="md:table-fixed table-auto overflow-x-auto container mx-auto px-4 text-left divide-gray-200  align-top">
                                <thead>
                                    <tr>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Datum</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Ort</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Fach</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Rahmenzeit</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Anz. SchülerInnen</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Prüfung</th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Vorsitz/<br>Hauptfachlehrender/<br>Fachk. Beisitz/<br>Ext. fachk. Beisitz
                                        </th>
                                        <th
                                            class="md:px-6 md:py-4 px-1 py-2 bg-gray-200 text-left text-base leading-4 font-medium text-gray-500">
                                            Anm.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pruefung, index) in formdata.existierendePruefungen" :key="index"
                                        :class="index % 2 == 0 ? 'bg-white' : 'bg-gray-100'">
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ getDate(pruefung.datum) }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.pruefungsOrt }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ getFachById(pruefung.fachId) }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.rahmenzeit }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.anzahlSchueler }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.pruefungsArt }}</td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.vorsitz }}<br>{{ pruefung.hauptfachlehrender }}<br>{{
                                                    pruefung.fachkundigerBeisitz
                                            }}<br>{{ pruefung.externerFachkundigerBeisitz
}}
                                        </td>
                                        <td
                                            class="md:px-6 md:py-4 px-1 py-2 text-sm leading-5 font-medium text-gray-900">
                                            {{ pruefung.anmerkungen }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </ValidationObserver>
        <ValidationObserver ref="modal">
            <transition name="fade">
                <div v-show="formbehaviour.showEditDialog" class="w-full h-full bg-gray-400 py-10">
                    <div v-show="formbehaviour.showEditDialog"
                        class="bg-white opacity-100 mx-auto my-10 rounded-lg px-4 pt-5 pb-4 shadow-xl transform transition-all max-w-xl sm:w-full sm:p-6">
                        <div class="grid grid-cols-6 gap-6">
                            <text-input label="Datum" rules="required|date" columns="3"
                                v-model="formdata.selectedPruefung.datum"></text-input>
                            <text-input label="PLZ, Ort und Adresse der Prüfung" rules="required" columns="3"
                                v-model="formdata.selectedPruefung.pruefungsOrt"></text-input>
                            <drop-down label="Fach" rules="required" v-model="formdata.selectedPruefung.fachId"
                                :values="formdata.faecherFuerPruefungsordnung"></drop-down>
                            <drop-down label="Prüfung" rules="required" v-model="formdata.selectedPruefung.pruefungsArt"
                                :values="[
                                    { id: 'Elementar', name: 'Junior (Elementar)' },
                                    { id: 'ÜP1', name: 'Bronze (ÜP1)' },
                                    { id: 'ÜP2', name: 'Silber (ÜP2)' },
                                    { id: 'Abschluss', name: 'Gold (Abschluss)' },
                                ]"></drop-down>
                            <button @click="initialisiereKommissionAusVorheriger()" type="button"
                                v-if="previousPruefungExists()"
                                class="col-span-3 text-center sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">Kommission
                                aus vorheriger Eingabe übernehmen.</button>
                            <text-input label="Vorsitz"
                                tooltip="Info: der Musikschulleiter kann eine Vertretung zum Vorsitz entsenden"
                                rules="required" v-model="formdata.selectedPruefung.vorsitz"></text-input>
                            <text-input label="Hauptfachlehrender"
                                tooltip="Info: der Hauptfachlehrende des Prüfungsfaches" rules="required"
                                v-model="formdata.selectedPruefung.hauptfachlehrender"></text-input>
                            <text-input label="Fachkundiger Beisitz"
                                tooltip="Info: bei Bronze muss der fachkundige Beisitz nicht vom gleichen Instrument sein. Z.B. kann ein Klarinettenlehrender Beisitz für Querflöte sein, ab Silber MUSS der fachkundige Beisitz das gleiche Instrument unterrichten"
                                rules="required" v-model="formdata.selectedPruefung.fachkundigerBeisitz"></text-input>
                            <text-input label="nur Gold: externer fachkundiger Beisitz"
                                v-if="formdata.selectedPruefung.pruefungsArt == 'Abschluss'"
                                tooltip="Der externe Fachbeisitz muss vom gleichen Instrument sein!"
                                rules="required" v-model="formdata.selectedPruefung.externerFachkundigerBeisitz">
                            </text-input>
                            <text-input label="Anzahl SchülerInnen" rules="required|numeric" columns="3"
                                v-model="formdata.selectedPruefung.anzahlSchueler"></text-input>
                            <text-input label="Rahmenzeit von - bis" rules="required" columns="3"
                                v-model="formdata.selectedPruefung.rahmenzeit"></text-input>
                            <text-area-input class="mb-6" label="Anmerkungen" tooltip="z.B. Konzert 18 Uhr" rows="3"
                                v-model="formdata.selectedPruefung.anmerkungen"></text-area-input>
                            <button @click="initSelectedPruefung()" type="button"
                                class="col-span-3 text-center sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-red-600 bg-red-100 hover:bg-red-300 focus:outline-none focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">Abbrechen</button>
                            <button @click="saveSelectedPruefung()" type="button"
                                class="col-span-3 text-center sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">Prüfung
                                hinzufügen</button>
                        </div>

                    </div>
                </div>
            </transition>

        </ValidationObserver>

        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
                <div v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900">
                                        Validierung erfolgreich.
                                    </p>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div v-show="formbehaviour.showDeleteDialog"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.showDeleteDialog" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.showDeleteDialog"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                            <svg class="h-6 w-6 text-red-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Wollen Sie den Eintrag wirklich löschen?
                            </h3>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <span class="flex w-full rounded-md shadow-sm">
                                <button
                                    @click="formdata.selectedPruefungIndex = ansuchen.pruefungen.length; formbehaviour.showDeleteDialog = false;"
                                    type="button"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-300 text-base leading-6 font-medium text-indigo-700 shadow-sm hover:bg-indigo-200 focus:outline-none focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                    Abbrechen
                                </button>
                                <button @click="removePruefung(formdata.selectedPruefungIndex)" type="button"
                                    class="inline-flex ml-1 justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                    Prüfung löschen
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.successful" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-md sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-5 font-medium text-gray-900">
                                Die Prüfungstermine wurden erfolgreich registriert.<br>
                                Sie erhalten in Kürze eine Bestätigungsemail an die angegebene Mailadresse.
                            </h3>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <span class="flex w-full rounded-md shadow-sm">
                                <button @click="returnAfterSave()" type="button"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                    Schließen
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
import FormHeader from '@/components/forms/FormHeader.vue';
import FormSection from '@/components/forms/FormSection.vue';
import DropDown from '@/components/inputs/DropDown.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import TextBlock from '@/components/inputs/TextBlock.vue';
import TextAreaInput from '@/components/inputs/TextAreaInput.vue';
import CheckBox from '@/components/inputs/CheckBox.vue';
import * as JsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable'

export default {
    name: 'Form',
    inject: ['service'],
    data: function () {
        return {
            formbehaviour: {
                alertrequired: false,
                sending: false,
                showSendModal: false,
                successful: false,
                showEditDialog: false,
                showDeleteDialog: false,
            },
            formdata: {
                musikschulen: [],
                datum: null,
                pruefungsOrt: null,
                faecherFuerPruefungsordnung: [],
                textbausteine: [],
                existierendePruefungen: [],
                selectedPruefung: null,
                selectedPruefungIndex: 0,
            },
            ansuchen: {
                musikschuleId: null,
                vornameKontakt: null,
                nachnameKontakt: null,
                email: null,
                telefon: null,
                pruefungen: [],
            },
            richtigBestaetigung: null,

        };
    },
    components: {
        FormHeader,
        FormSection,
        DropDown,
        TextInput,
        TextBlock,
        TextAreaInput,
        CheckBox,
    },
    computed: {
        musikschuleId: {
            get: function () {
                return this.ansuchen.musikschuleId;
            },
            set: function (val) {
                this.fetchPruefungenForMusikschule(val);
                this.ansuchen.musikschuleId = val;
            }
        }
    },
    methods: {
        initialisiereKommissionAusVorheriger() {
            if (!this.formdata.selectedPruefung.fachId)
                return;

            var previous = this.ansuchen.pruefungen.find((el) => el.fachId == this.formdata.selectedPruefung.fachId);
            if (!previous)
                return;

            this.formdata.selectedPruefung.vorsitz = previous.vorsitz;
            this.formdata.selectedPruefung.hauptfachlehrender = previous.hauptfachlehrender;
            this.formdata.selectedPruefung.fachkundigerBeisitz = previous.fachkundigerBeisitz;
            this.formdata.selectedPruefung.externerFachkundigerBeisitz = previous.externerFachkundigerBeisitz;
        },
        previousPruefungExists() {
            return this.ansuchen.pruefungen.find((el) => el.fachId == this.formdata.selectedPruefung.fachId);
        },
        returnAfterSave() {
            this.initSelectedPruefung();
            this.formdata.datum = null;
            this.formdata.pruefungsOrt = null;
            this.formdata.existierendePruefungen = this.formdata.existierendePruefungen.concat(this.ansuchen.pruefungen);
            this.ansuchen.pruefungen = [];
            this.richtigBestaetigung = null;
            this.formbehaviour.successful = false;
        },
        initSelectedPruefung() {
            this.formdata.selectedPruefung = {
                datum: null,
                anzahlSchueler: null,
                pruefungsOrt: null,
                fachId: null,
                pruefungsArt: null,
                vorsitz: null,
                hauptfachlehrender: null,
                fachkundigerBeisitz: null,
                externerFachkundigerBeisitz: null,
                rahmenzeit: null,
                anmerkungen: null,
            };

            this.formdata.selectedPruefungIndex = this.ansuchen.pruefungen.length;
            this.formbehaviour.showEditDialog = false;
        },
        newPruefung() {
            this.formdata.selectedPruefung = {
                datum: this.formdata.datum,
                anzahlSchueler: null,
                pruefungsOrt: this.formdata.pruefungsOrt,
                fachId: null,
                pruefungsArt: null,
                vorsitz: null,
                hauptfachlehrender: null,
                fachkundigerBeisitz: null,
                externerFachkundigerBeisitz: null,
                rahmenzeit: null,
                anmerkungen: null,
            };
            if (this.$refs.modal) this.$refs.modal.reset();
            this.formbehaviour.showEditDialog = true;
            this.formdata.selectedPruefungIndex = this.ansuchen.pruefungen.length;
        },
        editPruefung(index) {
            if (this.ansuchen.pruefungen.length > index) {
                var selected = this.ansuchen.pruefungen[index];
                this.formdata.selectedPruefungIndex = index;

                this.formdata.selectedPruefung = {
                    datum: selected.datum,
                    anzahlSchueler: selected.anzahlSchueler,
                    pruefungsOrt: selected.pruefungsOrt,
                    fachId: selected.fachId,
                    pruefungsArt: selected.pruefungsArt,
                    vorsitz: selected.vorsitz,
                    hauptfachlehrender: selected.hauptfachlehrender,
                    fachkundigerBeisitz: selected.fachkundigerBeisitz,
                    externerFachkundigerBeisitz: selected.externerFachkundigerBeisitz,
                    rahmenzeit: selected.rahmenzeit,
                    anmerkungen: selected.anmerkungen,
                };
                this.formbehaviour.showEditDialog = true;
            }
        },
        getDate(val) {
            if (!val) return null;
            return (val.split(' '))[0];
        },
        removePruefung(index) {
            this.ansuchen.pruefungen.splice(index, 1);
            this.ansuchen.selectedPruefungIndex = this.ansuchen.pruefungen.length;
            this.formbehaviour.showDeleteDialog = false;
        },
        async saveSelectedPruefung() {
            var validation = await this.$refs.modal.validate();
            if (validation && this.formdata.selectedPruefungIndex <= this.ansuchen.pruefungen.length) {
                if (this.formdata.selectedPruefungIndex == this.ansuchen.pruefungen.length) {
                    this.ansuchen.pruefungen.push(this.formdata.selectedPruefung);
                } else {
                    this.ansuchen.pruefungen[this.formdata.selectedPruefungIndex] = this.formdata.selectedPruefung;
                }
                this.initSelectedPruefung();
                window.scrollTo(0, 0);
            }
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            );
            if (!found) return id;

            return found.content;
        },
        getFachById(fachid) {
            if (this.formdata.faecherFuerPruefungsordnung) {
                const pFach = this.formdata.faecherFuerPruefungsordnung.find(fach => fach.id == fachid);
                if (pFach && pFach.name) return pFach.name;
            }
            return null;
        },
        async fetchTextbausteine() {
            const { data } = await this.service.formular
                .get('pruefungsordnung')
                .textbloeckePowerApps();
            this.formdata.textbausteine = data;
        },
        async fetchMusikschulen() {
            const { data } = await this.service.pruefungsordnung.getMusikschulen();
            this.formdata.musikschulen = data;
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchFaecher() {
            const { data } = await this.service.fach.pruefungsordnung();
            this.formdata.faecherFuerPruefungsordnung = data;
        },
        async fetchPruefungenForMusikschule(musikschuleId) {
            const { data } = await this.service.pruefungsordnung.getVorhandene(musikschuleId);
            this.formdata.existierendePruefungen = data;
        },
        async openSubmitModal() {
            var validation = await this.$refs.form.validate();

            if (!validation) {
                window.scrollTo(0, 0);
                this.formbehaviour.alertrequired = true;
                return;
            }

            this.formbehaviour.showSendModal = true;

        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate();

            if (!validation) {
                window.scrollTo(0, 0);
                this.formbehaviour.alertrequired = true;
                return;
            }
            try {
                this.formbehaviour.sending = true;
                await this.service.pruefungsordnung.senden(this.ansuchen);
                this.formbehaviour.showSendModal = false;
                this.formbehaviour.successful = true;

            } catch (error) {
                console.log(Object.keys(error), error.message);

            } finally {
                this.formbehaviour.sending = false;

            }
        },
        generatePdf(listOfPruefungen) {
            var doc = new JsPDF('landscape')

            let x = 20
            let y = 30

            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(
                x,
                y,
                'Prüfungen'
            )

            doc.setFontType('normal');
            doc.setFontSize(11);

            doc.text(x, y + 6, 'Musikschule:')
            doc.text(x, y + 12, 'Kontakt:')
            doc.text(x, y + 18, 'Mail:')
            doc.text(x, y + 24, 'Mobiltelefon:')

            doc.text(x + 30, y + 6, (this.ansuchen.musikschuleId ? (this.formdata.musikschulen.find(a => a.id == this.ansuchen.musikschuleId)).name : ''))
            doc.text(x + 30, y + 12, (this.ansuchen.vornameKontakt && this.ansuchen.nachnameKontakt) ? this.ansuchen.vornameKontakt + ' ' + this.ansuchen.nachnameKontakt : '')
            doc.text(x + 30, y + 18, this.ansuchen.email ? String(this.ansuchen.email) : '');
            doc.text(x + 30, y + 24, this.ansuchen.telefon ? String(this.ansuchen.telefon) : '');

            y += 30;

            var pruefungenVals = listOfPruefungen.map(pruefung => [
                this.getDate(pruefung.datum),
                pruefung.pruefungsOrt,
                this.getFachById(pruefung.fachId),
                pruefung.rahmenzeit,
                pruefung.anzahlSchueler,
                pruefung.pruefungsArt,
                pruefung.vorsitz + ' / ' +
                pruefung.hauptfachlehrender + ' / ' +
                pruefung.fachkundigerBeisitz + ' / ' +
                pruefung.externerFachkundigerBeisitz,
                pruefung.anmerkungen
            ]);
            doc.autoTable({
                head: [['Datum', 'Ort', 'Fach', 'Rahmenzeit', 'Anz. SchülerInnen', 'Prüfung', 'Vorsitz/Hauptfachlehrender/Fachk. Beisitz/Ext. fachk. Beisitz', 'Anmerkungen']],
                body: pruefungenVals,
                startY: y,
                styles: {
                    fontSize: 10,
                },
            });
            doc.save('Prüfungen.pdf');
        }
    },
    created() {
        this.initSelectedPruefung();
        this.fetchMusikschulen();
        this.fetchFaecher();
        this.fetchTextbausteine();
    }

}
</script>

<style scoped>
[data-tooltip]:hover {
    position: relative;
}

[data-tooltip]:hover::before {
    all: initial;
    font-family: Arial, Helvetica, sans-serif;
    display: inline-block;
    border-radius: 5px;
    padding: 10px;
    background-color: #777;
    content: attr(data-tooltip);
    color: #f9f9f9;
    position: absolute;
    bottom: 100%;
    width: 300px;
    left: 50%;
    transform: translate(-50%, 0);
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
}
</style>
